import { useEffect, useState } from 'react';
import breakpoints from 'common/config/breakpoints';

const mediaMatchers = breakpoints.reduce((
  matchers,
  { breakpoint, size }
) => {
  matchers[size] = matchMedia(breakpoint);

  return matchers;
}, {});

const getMediaMatch = () => {
  const mediaMatch = { activeBreakpoint: 'base' };

  Object.entries(mediaMatchers).forEach(([key, mediaQuery]) => {
    mediaMatch[key] = mediaQuery.matches;

    if (mediaQuery.matches) {
      mediaMatch.activeBreakpoint = key;
    }
  });

  return mediaMatch;
};

const useResponsive = () => {
  const [state, setState] = useState(getMediaMatch());

  useEffect(() => {
    const updateMedia = () => {
      setState(getMediaMatch);
    };

    Object.values(mediaMatchers).forEach((mediaQuery) => {
      mediaQuery.addListener(updateMedia);
    });

    return () => {
      Object.values(mediaMatchers).forEach((mediaQuery) => {
        mediaQuery.removeListener(updateMedia);
      });
    };
  }, []);

  return state;
};

export default useResponsive;
